import * as React from 'react';
import { SVGProps } from 'react';

const IconWellFolderSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.7 1a.7.7 0 0 0-.7.7V11a1 1 0 0 0 1 1h4.573l2.585-5.17a1.5 1.5 0 0 1 2.684 0l2.58 5.16A.7.7 0 0 0 15 11.3V4a1 1 0 0 0-1-1h-3.586a1 1 0 0 1-.707-.293L8.293 1.293A1 1 0 0 0 7.586 1H1.7Z"
      fill="var(--color-bg-caution)"
    />
    <path
      d="M1 3.7V11a1 1 0 0 0 1 1h4.573l2.585-5.17a1.5 1.5 0 0 1 2.684 0l2.58 5.16A.7.7 0 0 0 15 11.3V4a1 1 0 0 0-1-1H1.7a.7.7 0 0 0-.7.7Z"
      fill="var(--color-bg-warning)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m11.97 13.796.188.375a1.5 1.5 0 0 0 2.684-1.342l-3-6a1.5 1.5 0 0 0-2.684 0l-3 6a1.5 1.5 0 1 0 2.684 1.342l.187-.375a1.5 1.5 0 0 0 2.942 0ZM10.5 7a.5.5 0 0 1 .447.276l3 6a.5.5 0 1 1-.894.448L11 9.618V13.5a.5.5 0 1 1-1 0V9.618l-2.053 4.106a.5.5 0 1 1-.894-.448l3-6A.5.5 0 0 1 10.5 7Z"
      fill="var(--color-typo-primary)"
    />
    <path
      d="M10.947 7.276a.5.5 0 0 0-.894 0l-3 6a.5.5 0 1 0 .894.448L10 9.618V13.5a.5.5 0 0 0 1 0V9.618l2.053 4.106a.5.5 0 1 0 .894-.448l-3-6Z"
      fill="var(--color-typo-normal)"
    />
  </svg>
);
export default IconWellFolderSizeS;
